import './platform/install';

// Всё приложение — динамическим import(): в продовой сборке сторы shared/
// попадают в общие чанки, а статически импортированный чанк выполняется
// раньше тела entry — до configurePlatform из install (белый экран
// «платформа не настроена»). Динамический импорт идёт строго после.
void import('./bootstrap');
